import { atom } from "recoil";

interface Stories {
    PresenceState: { MBP: boolean, stories: boolean };
}

export const PresenceState = atom({
    key: 'isPresenceChecked',
    default: { MBP: true, stories: false } as any,
});

export const expandedPresenceConfigState = atom<number | null>({
    key: 'expandedPresenceConfig',
    default: null,
});